import Button from 'components/common/Button/Button';
import styled from 'styled-components';
import {device} from 'styled/device';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;

export const SuccessIcon = styled.img.attrs({className: 'checkin-completed-modal__icon'})`
  width: 150px;
  height: 150px;
`;

export const ContainerInformation = styled.div`
  margin: 48px 24px;

  @media (min-width: ${device.tablet}) {
    margin: 16px 24px;
  }
`;

export const Title = styled.h2.attrs({className: 'checkin-completed-modal__title'})`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.36px;
  color: #152946;
`;

export const Subtitle = styled.p.attrs({className: 'checkin-completed-modal__title'})`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #152946;
  text-align: center;
`;
export const ContainerButton = styled.div`
  @media (min-width: ${device.tablet}) {
    margin-top: 48px;
  }
`;

export const ConfirmButton = styled(Button)`
  margin: 0 auto;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: -0.15px;
  width: 205px;
  /* margin-top: 36px; */

  @media (min-width: ${device.mobileM}) {
    width: 327px;
  }
`;
